<template>
  <div class="pageOverflow">
    <div class="pageFlex">
      <div class="block">
        <span class="demonstration">收入明细：</span>
        <yz-daterange @dateRange="getChooseTimeOne"></yz-daterange>
        <!-- <el-button class="ml_20"  type="primary" @click="search">搜索</el-button> -->
      </div>
      <div class="commonTable">
        <el-table tooltip-effect="light" :data="tableData">
          <el-table-column prop="payTime" label="日期">
          </el-table-column>
          <el-table-column prop="dutyName" label="当班人">
          </el-table-column>
          <el-table-column prop="total" label="收入总额（元）">
          </el-table-column>
          <el-table-column prop="wxPay" label="扫码">
          </el-table-column>
          <el-table-column prop="vipPay" label="会员卡">
          </el-table-column>
          <el-table-column prop="bankPay" label="银行卡">
          </el-table-column>
          <el-table-column prop="cashPay" label="现金">
          </el-table-column>
          <el-table-column prop="creditPay" label="赊账">
          </el-table-column>
          <el-table-column prop="magicBoxPay" label="魔盒">
          </el-table-column>
          <el-table-column prop="personWxPay" label="个人微信">
          </el-table-column>
          <el-table-column prop="personAliPay" label="个人支付宝">
          </el-table-column>
        </el-table>
      </div>
      <div class="block table_clear">
        <el-pagination background :current-page.sync="pageNum" :page-size="5" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>

      <div class="block">
        <span class="demonstration">钱箱提现记录：</span>
        <yz-daterange @dateRange="getChooseTimeTwo"></yz-daterange>
        <!-- <el-button class="ml_20"  type="primary" @click="search2">搜索</el-button> -->
      </div>
      <div class="commonTable">
        <el-table tooltip-effect="light" :data="tableData2">
          <el-table-column prop="createTimeStr" label="创建时间">
          </el-table-column>
          <el-table-column prop="handlerName" label="经手人">
            <template slot-scope="scope">
              <span v-if="scope.row.handlerName">{{ scope.row.handlerName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="dutyName" label="当班人">
          </el-table-column>
          <el-table-column prop="money" label="提现金额（元）">
          </el-table-column>
          <el-table-column prop="balance" label="余额（元）" width="120">
          </el-table-column>
        </el-table>
      </div>
      <div v-if="tableData2.length > 0" class="blockThree">
        <el-pagination background :current-page.sync="pageNum2" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount2" @size-change="handleSizeChange2" @current-change="handleCurrentChange2">
        </el-pagination>
      </div>
    </div>
    <gt-footer></gt-footer>
  </div>
</template>

<script>
import api from '../../api/index.js';

export default {
  data() {
    return {
      value: '', // 时间段--收入明细
      value2: '', // 时间段--钱箱提现记录
      inputVal: '', // 搜索值--收入明细
      inputVal2: '', // 搜索值--钱箱提现记录
      pageNum: 1,
      pageNum2: 1,
      rowCount: 1,
      rowCount2: 1,
      tableData: [], // 收入明细列表
      tableData2: [] // 钱箱提现记录列表
    };
  },
  activated() {
    this.getListData();
    this.getListData2();
  },
  methods: {
    // 得到子组件选择的时间
    getChooseTimeOne(time) {
      this.value = time;
      this.getListData();
    },
    // 得到子组件选择的时间
    getChooseTimeTwo(time) {
      this.value2 = time;
      this.getListData2(time);
    },
    // 搜索--收入明细
    search() {
      this.pageNum = 1;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 收入明细列表
    getListData() {
      const vm = this;
      const data = {
        startDate: '',
        endDate: '',
        pageNum: vm.pageNum
      };
      if (vm.value) {
        data.startDate = vm.value[0];
        data.endDate = vm.value[1];
      }
      api.getDbjl(data).then((res) => {
        vm.tableData = res.data.list;
        vm.rowCount = res.data.rowCount;
      });
    },
    // 搜索--钱箱提现记录
    search2() {
      this.pageNum2 = 1;
      this.getListData2();
    },
    handleSizeChange2(val) {
      this.pageNum2 = val;
      this.getListData2();
    },
    handleCurrentChange2(val) {
      this.pageNum2 = val;
      this.getListData2();
    },
    // 钱箱提现记录
    getListData2() {
      const vm = this;
      const data = {
        startDate: '',
        endDate: '',
        pageNum: vm.pageNum2
      };
      if (vm.value2) {
        data.startDate = vm.value2[0];
        data.endDate = vm.value2[1];
      }
      api.getQxtx(data).then((res) => {
        vm.tableData2 = res.data.list;
        vm.rowCount2 = res.data.rowCount;
      });
    }
  }
};
</script>
